import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'tkc-modification-buttons',
  templateUrl: './modification-buttons.component.html',
  styleUrls: ['./modification-buttons.component.scss'],
  imports: [SharedModule]
})
export class ModificationButtonsComponent {
  @Input() isModificationsPending: boolean = false;
  @Input() saveModifications!: () => void;
  @Input() resetModifications!: () => void;
  @Input() showReset?: boolean = true;
  @Input() showSave?: boolean = true;
  @Input() matTooltipContent?: string|undefined = undefined;
  @Input() isErrorTooltipSaveBtn: boolean = false;
}
